import { useEffect } from 'react';

/**
 * Meta Pixel — Acro Yoga Class Ready (DPS44).
 * Un solo pixel, un solo PageView por carga de página.
 */
const PIXEL_ID = '1638655871007030';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelInitialized?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Guard global: nunca inicializar ni trackear dos veces (re-montajes, HMR).
    if (window.__metaPixelInitialized) return;
    window.__metaPixelInitialized = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}